import i18next from "../../i18n";
import AwardedTableRow from "./AwardedTableRow/AwardedTableRow";
import { OfferAwardedForDeliveryResponse } from "../../types";

const awardedTableTh = [
  { id: 1, name: i18next.t("deliveries.form.orderName") },
  { id: 2, name: i18next.t("deliveries.companyName") },
  { id: 3, name: i18next.t("deliveries.supplierName") },
  { id: 4, name: i18next.t("deliveries.supplierEmail") },
  { id: 5, name: i18next.t("deliveries.materialCount") },
  { id: 6, name: "" },
];

type AwardedTableProps = {
  awardedOrdersSuppliers: OfferAwardedForDeliveryResponse[];
  handleSupplierSelect: (item: OfferAwardedForDeliveryResponse) => void;
};

const AwardedTable = ({
  awardedOrdersSuppliers,
  handleSupplierSelect,
}: AwardedTableProps) => {
  return (
    <div className="mt-4">
      <div className="flex flex-col mt-2">
        <div className="align-middle min-w-full overflow-x-auto shadow overflow-hidden rounded">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {awardedTableTh?.map((th) => (
                  <th
                    key={th.id}
                    scope="col"
                    className="px-2 py-2 text-left text-xxs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {th.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {awardedOrdersSuppliers?.map((off) => (
                <AwardedTableRow
                  key={off.supplier.id}
                  awardedOrdersSuppliers={off}
                  handleSupplierSelect={handleSupplierSelect}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AwardedTable;
